import ProfileImageSmall from "./ProfileImageSmall";

/**
 * A small widget with a profile image, title and subtitle in the form:
 *
 *    [img]  Title
 *    [   ]  subtitle
 *
 */
const ProfileQuickLook = ({
  title,
  subtitle,
  imageSrc,
  className,
  imageClassName,
  titleClassName,
  subtitleClassName
}: {
  title: string;
  subtitle: string;
  imageSrc?: string;
  className?: string;
  imageClassName?: string;
  titleClassName?: string;
  subtitleClassName?: string;
}) => (
  <article
    className={"flex w-fit items-center justify-center gap-4 mt-4 " + className}
  >
    <ProfileImageSmall
      src={imageSrc}
      className={imageClassName || "bg-ctb-blue-300"}
    />

    <div>
      <h4 className={"text-sm leading-[150%] " + titleClassName}>{title}</h4>
      <p className={"text-xs leading-[150%] " + subtitleClassName}>
        {subtitle}
      </p>
    </div>
  </article>
);

export default ProfileQuickLook;
